<script>
/**
 * ****************************************************************************
 * @description     :   Input Search Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import { mapMutations } from 'vuex';
import repository from '@/utils/repository';
import helpers from '@/utils/helpers';

import SamplePopupSearch from '@/views/popup/samplePopupSearch';
import Employees from '@/views/popup/employees';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input search component
 */
var AnsInputSearch = {
    template: template,
    components: {
        SamplePopupSearch,
        Employees
    },
    props: {
        id: String,
        label: String,
        size: String,
        maxLength: Number,
        placeholder: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        icon: {
            type: String,
            default: 'fas fa-search'
        },
        //-------------------------
        isRequired: Boolean,
        isReadonly: Boolean,
        isDisabled: Boolean,
        isDisabledInput: Boolean,
        isShowClear: Boolean,
        isDisabledClear: Boolean,
        isCallOnChangeInput: {
            type: Boolean,
            default: true
        },
        //-------------------------
        value: String | Number,
        modelValue: Object | String | Number,
        index: String | Number,
        initData: Object,
        pageSearch: String,
        screen: String,
        //--------------------------
        propertyForId: String,
        propertyForName: String,
        isShowName: {
            type: Boolean,
            default: false
        },
        isShowLabel: Boolean,
        isSecondPopup: Boolean,
        isModalHeader: {
            type: Boolean,
            default: true
        },
        //-----------------------
        onChange: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: '',
            show: false,
            popup: ''
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
    },
    unmounted() {
        this.hidePopup();
    },
    computed: {
        vewValue() {
            if (
                this.isShowName &&
                this.modelValue &&
                this.modelValue[this.propertyName]
            ) {
                return this.modelValue[this.propertyName];
            }
            if (this.modelValue && this.modelValue[this.propertyId]) {
                return this.modelValue[this.propertyId];
            }
            return '';
        },
        propertyId() {
            if (this.propertyForId) {
                return this.propertyForId;
            }
            return 'code';
        },
        propertyName() {
            if (this.propertyForName) {
                return this.propertyForName;
            }
            return 'name';
        },
        modalTitle() {
            /*eslint indent: [2, 4, {"SwitchCase": 1}]*/
            switch (this.pageSearch) {
                case 'employees':
                    return '従業員検索';
                default:
                    return '検索画面';
            }
        },
        referWhenChange() {
            /*eslint indent: [2, 4, {"SwitchCase": 1}]*/
            switch (this.pageSearch) {
                case 'employees':
                    return {
                        url: `common/search/employees`
                    };
                default:
                    return {};
            }
        },
        realMaxLength() {
            return this.maxLength;
        }
    },
    methods: {
        ...mapMutations('app', ['hideHeaderError']),
        /**
         * update value for input search
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(item) {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, item, '');
            } else {
                this.$emit('update:modelValue', item);
            }
        },
        /**
         * remove value for input search
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        clearInput() {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, null, '');
            } else {
                this.$emit('update:modelValue', null);
            }
        },
        hidePopup() {
            this.show = false;
            this.hideHeaderError();
        },
        showPopup() {
            this.show = true;
            this.popup = this.pageSearch;
            this.hideHeaderError();
        },
        changeInput(e) {
            if (this.onChange) {
                const refer = this.referWhenChange;
                if (
                    refer.url &&
                    this.isCallOnChangeInput &&
                    !helpers.isNullOrEmpty(e.target?.value?.trim())
                ) {
                    repository
                        .get(refer.url, {
                            params: {
                                p002: e.target?.value?.trim(),
                                P003: 1
                            }
                        })
                        .then((res) => {
                            const { data } = res;
                            let item = null;
                            if (
                                data.Code === 200 &&
                                data.Data.employees.length > 0
                            ) {
                                item = _.find(data.Data.employees, (x) => {
                                    return x.コード == e.target?.value?.trim();
                                });
                            }
                            this.onChange(
                                this.index,
                                this.modelValue,
                                item,
                                e.target.value
                            );
                        });
                } else {
                    this.onChange(
                        this.index,
                        this.modelValue,
                        null,
                        e.target.value
                    );
                }
            }
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        getRealMaxLength() {
            return this.maxLength ?? 100;
        }
    }
};
export default AnsInputSearch;
</script>
